import axios from "axios";
import { AboutYou1FormData, AboutYou2FormData } from "features/checkIn/types";

type AboutYouParams = AboutYou1FormData &
  AboutYou2FormData & {
    appointment_id?: string;
  };

export const saveAdds = async (params: AboutYouParams): Promise<void> => {
  await axios.post(`/api/checkins/save_adds`, {
    address1: params.address1,
    address2: params.address2,
    state: params.state,
    city: params.city,
    zip_code: params.zipCode,
    race: params.race,
    ethnicity: params.ethnicity,
    patient_id: params.patient_id,
    appointment_id: params.appointment_id,
    gender: params.gender,
  });
};
